<template>
  <div id="staffScanTemperatureWithBarCode">
    <!--        web view-->
    <div style="padding: 20px; background: #ffffff; text-align: left" v-if="!checkMobileStatus">
      <img src="../assets/Vector24.png" />
      <span style="color: #536170; font-weight: 500; margin-left: 5px; display: inline-block">Temperature Scan</span>
    </div>

    <div class="container" v-if="!checkMobileStatus">
      <div class="bluetooth-connect-container" style="text-align: left; margin-top: 30px; margin-bottom: 30px">
        <span style="color: #4f4f4f; margin-bottom: 5px; display: block">Connect to Thermometer Scanner</span>

        <div class="row" style="margin: 0px; padding: 20px; background: #ffffff; border-radius: 5px">
          <div style="width: 15%">
            <img src="../assets/tempC.png" v-if="thermometerStatus" style="width: 80px; height: 80px; background: #e9edf7; border-radius: 50%" />
            <img src="../assets/tempD.png" v-if="!thermometerStatus" style="width: 80px; height: 80px; background: #e9edf7; border-radius: 50%" />
          </div>

          <div class="row" style="margin: 15px 0px; width: 80%">
            <div style="width: 80%">
              <label style="color: #536170; margin-bottom: 0px" v-if="thermometerStatus">Thermometer Scanner is Connected</label>
              <label style="color: #536170; margin-bottom: 0px" v-if="!thermometerStatus">Thermometer Scanner is Disconnected</label>
              <small style="color: #4f4f4f">You may proceed to take temperature</small>
            </div>

            <div style="width: 15%">
              <el-switch v-model="thermometerStatus" @change="checkThermoStatus()"></el-switch>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin: 0px">
        <div style="width: 49%">
          <span style="color: #4f4f4f; display: block; text-align: left; margin-bottom: 5px">Scan Student Barcode</span>

          <div style="background: #ffffff; border-radius: 5px; padding: 20px; height: 300px; max-height: 300px">
            <span style="color: #4f4f4f; display: block; font-size: 12px; margin-bottom: 15px"> ** Using barcode scanner scan student index no </span>

            <div style="width: 100%">
              <input class="form-control" v-model="barcodeIndexNo" @change="changeStudent(barcodeIndexNo)" />
            </div>
          </div>
        </div>

        <div style="width: 49%; margin-left: auto">
          <span style="color: #4f4f4f; display: block; text-align: left; margin-bottom: 5px">Search Student Manually</span>

          <div style="background: #ffffff; border-radius: 5px; padding: 20px; height: 300px; max-height: 300px">
            <span style="color: #4f4f4f; display: block; font-size: 12px; margin-bottom: 15px">If scan barcode fail, can manually choose student</span>

            <div style="width: 100%">
              <input
                class="form-control student-search"
                type="text"
                v-on:keyup="searchStudent()"
                v-model="searchValue"
                placeholder="Search Student"
                title="Search Student"
                style="background: #f8faff; border: 1px solid #eeeeee; border-radius: 5px"
              />

              <div class="student-list-container" style="margin-top: 20px; overflow: auto; width: 100%; max-height: 165px">
                <div
                  class="student-each-container"
                  v-for="studList in filterAllStudentList"
                  v-if="filterAllStudentList.length > 0"
                  @click="changeStudent(studList.Index_No)"
                >
                  <span>{{ studList.First_Name + studList.Middle_Name + studList.Last_Name }}</span>
                </div>

                <div v-if="filterAllStudentList.length <= 0">
                  <span>Empty List</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--        ok-only-->
      <b-modal
        id="modal_ScanDetails"
        title="Student details"
        ref="modal_ScanDetails"
        centered
        :ok-title="lang('SAVE')"
        @ok="saveStudTemp"
        :cancel-title="lang('CLOSE')"
        @hide="closeScanModal"
        @cancel="closeScanModal"
      >
        <div style="text-align: left; padding: 20px">
          <div class="row" style="margin: 0px">
            <div style="width: 48%">
              <label>Student Name</label>
              <input type="text" disabled="disabled" v-model="studName" class="form-control" style="width: 100%; background: #e9edf7; color: #222222" />
            </div>

            <div style="width: 48%; margin-left: auto">
              <label>Student ID</label>
              <input type="text" disabled="disabled" v-model="studID" class="form-control" style="width: 100%; background: #e9edf7; color: #222222" />
            </div>
          </div>

          <div class="row" style="margin: 0px">
            <div style="width: 48%">
              <label>In or Out</label>
              <select v-model="userType" class="form-control" style="width: 100%; background: #f8faff">
                <option value="IN">In</option>
                <option value="OUT">Out</option>
              </select>
            </div>

            <div style="width: 48%; margin-left: auto">
              <label>Temperature Reading (If manually input, press Enter to Remark)</label>
              <input v-model="studTemp" @keypress="onlyNumber($event)" class="form-control" style="width: 100%; background: #f8faff" />
            </div>
          </div>

          <div>
            <label>Remark</label>
            <!--                    <input v-model="studRemark" class="form-control" style="width: 100%;" />-->
            <textarea rows="4" v-model="studRemark" class="form-control" style="width: 100%; resize: none"></textarea>
          </div>
        </div>
      </b-modal>
    </div>

    <!--        mobile view-->
    <div style="padding: 20px; background: #413f56; text-align: left" v-if="checkMobileStatus">
      <span style="font-weight: 500; display: inline-block; color: #ffffff">Temperature Scan</span>
    </div>

    <div v-if="checkMobileStatus" style="position: relative">
      <div style="padding: 0px 20px">
        <div class="bluetooth-connect-container" style="text-align: left; margin-top: 30px; margin-bottom: 30px">
          <span style="color: #4f4f4f; margin-bottom: 10px; display: block">Connect to Thermometer Scanner</span>

          <div class="row" style="margin: 0px; padding: 20px; background: #ffffff; border-radius: 5px; align-items: center; justify-content: center">
            <div style="width: 20%">
              <img src="../assets/tempC.png" v-if="thermometerStatus" style="width: 60px; height: 60px; background: #e9edf7; border-radius: 50%" />
              <img src="../assets/tempD.png" v-if="!thermometerStatus" style="width: 60px; height: 60px; background: #e9edf7; border-radius: 50%" />
            </div>

            <div class="row" style="margin: 15px 0px 15px auto; width: 78%">
              <div style="width: 80%">
                <label style="color: #536170; margin-bottom: 0px" v-if="thermometerStatus">Thermometer Scanner is Connected</label>
                <label style="color: #536170; margin-bottom: 0px" v-if="!thermometerStatus">Thermometer Scanner is Disconnected</label>
                <small style="color: #4f4f4f">You may proceed to take temperature</small>
              </div>

              <div style="width: 15%">
                <el-switch v-model="thermometerStatus" @change="checkThermoStatus()"></el-switch>
              </div>
            </div>
          </div>
        </div>

        <div style="width: 100%">
          <span style="color: #4f4f4f; display: block; text-align: left; margin-bottom: 10px">Scan Student Barcode</span>

          <div style="background: #ffffff; border-radius: 5px; padding: 40px; height: 300px; max-height: 300px">
            <span style="color: #4f4f4f; display: block; font-size: 12px; margin-bottom: 15px"> ** Using barcode scanner scan student index no </span>

            <div style="width: 100%">
              <input
                class="form-control"
                type="text"
                v-model="barcodeIndexNo"
                @change="changeStudent(barcodeIndexNo)"
                style="background: #f8faff; border: 1px solid #eeeeee; border-radius: 5px"
              />
            </div>
          </div>
        </div>
      </div>

      <div style="position: relative; bottom: -53px" v-if="isSearch">
        <div style="background: #ffffff; border-radius: 5px; padding: 20px; height: 300px; max-height: 300px; text-align: left">
          <span style="color: #4f4f4f; display: block; margin-bottom: 10px">Search Student Manually</span>

          <span style="color: #4f4f4f; display: block; font-size: 12px; margin-bottom: 15px">If scan barcode fail, can manually choose student</span>

          <div style="width: 100%">
            <input
              class="form-control student-search"
              type="text"
              v-on:keyup="searchStudent()"
              v-model="searchValue"
              placeholder="Search Student"
              title="Search Student"
              style="background: #f8faff; border: 1px solid #eeeeee; border-radius: 5px"
            />

            <div class="student-list-container" style="margin-top: 20px; overflow: auto; width: 100%; max-height: 165px">
              <div
                class="student-each-container"
                v-for="studList in filterAllStudentList"
                v-if="filterAllStudentList.length > 0"
                @click="changeStudent(studList.Index_No)"
              >
                <span>{{ studList.First_Name + studList.Middle_Name + studList.Last_Name }}</span>
              </div>

              <div v-if="filterAllStudentList.length <= 0">
                <span>Empty List</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="position: relative; bottom: -55px">
        <button class="btn btn-primary" @click="showSearch()">Search Student Manually</button>
      </div>

      <!--        ok-only-->
      <b-modal
        id="modal_ScanDetails"
        title="Student details"
        ref="modal_ScanDetails"
        centered
        :ok-title="lang('SAVE')"
        @ok="saveStudTemp"
        :cancel-title="lang('CLOSE')"
        @hide="closeScanModal"
        @cancel="closeScanModal"
      >
        <div style="text-align: left; padding: 20px">
          <div class="row" style="margin: 0px">
            <div style="width: 100%">
              <label>Student Name</label>
              <input type="text" disabled="disabled" v-model="studName" class="form-control" style="width: 100%; background: #e9edf7; color: #222222" />
            </div>

            <div style="width: 100%">
              <label>Student ID</label>
              <input type="text" disabled="disabled" v-model="studID" class="form-control" style="width: 100%; background: #e9edf7; color: #222222" />
            </div>
          </div>

          <div class="row" style="margin: 0px">
            <div style="width: 100%">
              <label>In or Out</label>
              <select v-model="userType" class="form-control" style="width: 100%; background: #f8faff">
                <option value="IN">In</option>
                <option value="OUT">Out</option>
              </select>
            </div>

            <div style="width: 100%">
              <label>Temperature Reading (If manually input, press Enter to Remark)</label>
              <input v-model="studTemp" @keypress="onlyNumber($event)" class="form-control" style="width: 100%; background: #f8faff" />
            </div>
          </div>

          <div>
            <label>Remark</label>
            <!--                    <input v-model="studRemark" class="form-control" style="width: 100%;" />-->
            <textarea rows="4" v-model="studRemark" class="form-control" style="width: 100%; resize: none"></textarea>
          </div>
        </div>
      </b-modal>
    </div>

    <!--        unuse (should be can delete)-->
    <div>
      <div class="" style="text-align: left; width: 100%; padding: 15px; display: none">
        <label>
          <!--                    {{devicesStatusMsg}}-->
          Thermometer Scanner is
          <select v-model="thermometerStatus" @change="checkThermoStatus()">
            <option value="connect">connect</option>
            <option value="disconnect">disconnect</option>
          </select>
        </label>
        <!--                <input class="btn btn-primary" type="submit" value="Connect"-->
        <!--                       @click="getDevices" style="display: inline-block;" />-->
        <!--                <input class="btn btn-primary" type="submit" value="Disconnect"-->
        <!--                       @click="onDisconnectButtonClick()" style="display: inline-block;" />-->
      </div>
    </div>

    <div style="text-align: left; width: 100%; padding: 15px; display: none">
      <div>
        <!--                <div style="width: 100%;">-->
        <!--                    <input class="btn btn-primary" type="submit" value="Start"-->
        <!--                           @click="triggerStartScan" style="display: inline-block;" />-->
        <!--                    <input class="btn btn-primary" type="submit" value="Stop"-->
        <!--                           @click="triggerStopScan" style="display: inline-block;" />-->
        <!--                </div>-->

        <!--                <label>-->
        <!--                    <select v-model="barcodeStatus" @change="checkBarcodeStatus()" style="margin-right: 10px;">-->
        <!--                        <option value="start">Start</option>-->
        <!--                        <option value="stop">Stop</option>-->
        <!--                    </select>-->

        <!--                    <span>Camera</span>-->
        <!--                    <select name="input-stream_constraints" id="deviceSelection">-->
        <!--                    </select>-->
        <!--                </label>-->

        <div v-if="allStudentList.length > 0" style="margin-top: 20px">
          <label>Select Student (* If scan barcode fail, can manually choose student)</label>
          <select v-model="selectedStudent" class="form-control" @change="changeStudent()">
            <option v-for="studList in allStudentList" :value="studList.Index_No">
              {{ studList.First_Name + studList.Middle_Name + studList.Last_Name }}
            </option>
          </select>
        </div>

        <!--                <div id="interactive" class="viewport" style="width: 100%;">-->
        <!--                </div>-->
        <!--                <qrcode-stream @decode="onDecode" @init="onInit" />-->
        <!--                <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>-->
      </div>
    </div>

    <div style="text-align: left; padding: 20px; display: none">
      <div>
        <label>In or Out</label>
        <select v-model="userType" class="form-control" style="width: 100%">
          <option value="IN">In</option>
          <option value="OUT">Out</option>
        </select>
      </div>

      <div>
        <label>Student ID</label>
        <input type="text" disabled="disabled" v-model="studID" class="form-control" style="width: 100%; background: #ffffff" />
      </div>

      <div>
        <label>Student Name</label>
        <input type="text" disabled="disabled" v-model="studName" class="form-control" style="width: 100%; background: #ffffff" />
      </div>

      <div>
        <label>Temperature Reading (If manually input, press Enter to Remark)</label>
        <input v-model="studTemp" @keypress="onlyNumber($event)" class="form-control" style="width: 100%" />
        <!--                <textarea rows="5" class="form-control" style="width: 100%;" v-model="studTemp" @keypress="onlyNumber($event)">{{studTemp}}</textarea>-->
      </div>
    </div>

    <div class="test container" style="display: none">
      <h1 class="text-primary">{{ title }}</h1>
      <p class="text-warning">v{{ version }}</p>
      <div class="" style="text-align: left; width: 100%; padding: 15px">
        <label>{{ devicesStatusMsg }}</label>
        <input class="btn btn-primary" type="submit" value="Connect" @click="getDevices" style="display: inline-block" />
        <input class="btn btn-primary" type="submit" value="Disconnect" @click="onDisconnectButtonClick()" style="display: inline-block; margin-left: 20px" />
      </div>
      <br />
      <div id="output-panel" class="panel panel-default">
        <div class="panel-heading">Output</div>
        <div id="output" class="panel-body">
          <div id="content"></div>
          <div id="status" class="text-danger"></div>
          <pre id="log" style="text-align: left"></pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import $ from 'jquery'
import { lang } from '../locale/index'

import Quagga from 'quagga' // ES6
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

export default {
  name: 'StaffScanTemperatureWithBarCode',
  components: {
    QrcodeStream,
  },
  data() {
    return {
      bluetoothDevice: '',
      title: 'Scanner',
      user: {
        firstName: 'Nick',
        lastName: 'Tsilivis',
      },
      message: '',
      version: '0.0.1',
      devicesStatusMsg: 'Thermometer Scanner is disconnect!',

      userType: 'IN',
      studID: '',
      studName: '',
      studTemp: '',
      studRemark: '',
      scanStudIndex: '',
      allStudentList: [],
      filterAllStudentList: [],
      selectedStudent: '',

      thermometerStatus: false,
      barcodeStatus: '',
      searchValue: '',
      checkMobileStatus: false,
      isSearch: false,

      myCharacteristic: '',
      barcodeIndexNo: '',
    }
  },
  props: [],
  async created() {
    // await window.addEventListener("load", this.onWindowLoad);
    await window.addEventListener('resize', this.isMobile)
    await this.getAllStudent()
  },
  async mounted() {
    this.isMobile()

    if (!navigator.bluetooth) {
      // this.setStatus('Web Bluetooth API is not available.\n');
      // alert("Encoded Message: " + encoder.encode("Makis"));

      this.$notify.error({
        title: lang('Error'),
        message: 'Web Bluetooth API is not available',
      })
    }
  },
  methods: {
    lang,

    startDevicesNotif() {
      if (navigator.bluetooth) {
        let serviceUuid = '0000fe18-0000-1000-8000-00805f9b34fb'

        let characteristicUuid = '0000fe10-0000-1000-8000-00805f9b34fb'

        navigator.bluetooth
          .requestDevice({ filters: [{ services: [serviceUuid] }] })
          .then(device => {
            console.log('Connecting to GATT Server...')
            return device.gatt.connect()
          })
          .then(server => {
            console.log('Getting Service...')
            return server.getPrimaryService(serviceUuid)
          })
          .then(service => {
            console.log('Getting Characteristic...')
            return service.getCharacteristic(characteristicUuid)
          })
          .then(characteristic => {
            this.myCharacteristic = characteristic
            return this.myCharacteristic.startNotifications().then(_ => {
              console.log('> Notifications started')
              this.myCharacteristic.addEventListener('characteristicvaluechanged', this.handleNotifications)
            })
          })
          .catch(error => {
            console.log('Argh! ' + error)
          })
      }
    },

    stopDevicesNotif() {
      if (this.myCharacteristic) {
        this.myCharacteristic
          .stopNotifications()
          .then(_ => {
            console.log('> Notifications stopped')
            this.myCharacteristic.removeEventListener('characteristicvaluechanged', this.handleNotifications)
          })
          .catch(error => {
            console.log('Argh! ' + error)
          })
      }
    },

    getDevices(e) {
      // e.preventDefault();

      // this.clearLog();

      if (navigator.bluetooth) {
        var myCharacteristic
        var bluetoothDevice

        let filters = []

        // let serviceUuid = document.querySelector('#service').value;
        let serviceUuid = '0000fe18-0000-1000-8000-00805f9b34fb'
        // this.log('Service UUID: ' + serviceUuid);

        let characteristicUuid = '0000fe10-0000-1000-8000-00805f9b34fb'

        // let message = document.querySelector('#message').value;

        // this.log('Characteristic UUID: ' + characteristicUuid);

        this.log('Requesting Bluetooth Device...')
        // bluetoothDevice.gatt.disconnect();

        navigator.bluetooth
          .requestDevice({
            // filters:[
            //     {namePrefix:'JXB'},
            //     {services:['0000fe18-0000-1000-8000-00805f9b34fb']}
            // ]
            acceptAllDevices: true,
          })
          .then(device => {
            bluetoothDevice = device
            this.bluetoothDevice = device

            this.log('-> Name:      ' + device.name)
            this.log('-> ID:        ' + device.id)
            console.log(device)

            bluetoothDevice.addEventListener('gattserverdisconnected', this.onDisconnected)
            // return this.connectDevices();
            return device.gatt.connect()
          })
          .then(server => {
            // this.log('Getting Service');
            return server.getPrimaryService(serviceUuid)
          })
          .then(service => {
            // this.log('Getting characteristic');
            if (characteristicUuid) {
              return service.getCharacteristic(characteristicUuid)
            }
          })
          .then(characteristic => {
            myCharacteristic = characteristic
            return myCharacteristic.startNotifications().then(_ => {
              this.log('> Notifications started')
              myCharacteristic.addEventListener('characteristicvaluechanged', this.handleNotifications)
            })
          })
          .then(_ => {
            this.log('Message successfully sent !')
            this.devicesStatusMsg = 'Thermometer Scanner is connected!'
          })
          // .then(characteristics => {
          //   console.log(characteristics);
          //   this.log('> Characteristics: ' + characteristics.map(c => c.uuid).join('\n' + ' '.repeat(19)));
          // })
          .catch(error => {
            this.log('Error: ' + error)
          })
      } else {
        alert('No Bluetooth detected')
      }
    },
    handleNotifications(event) {
      let value = event.target.value
      if (value.byteLength == 15) {
        // console.log(value);
        let a = []
        // Convert raw data bytes to hex values just for the sake of showing something.
        // In the "real" world, you'd use data.getUint8, data.getUint16 or even
        // TextDecoder to process raw data bytes.
        for (let i = 0; i < value.byteLength; i++) {
          a.push('0x' + ('00' + value.getUint8(i).toString(16)).slice(-2))
        }
        //this.log('> ' + a.join(' '));
        // console.log(a);
        if (a[1] == '0x20') {
          //double surface = a[4] * 256 + a[3]/10.0;
          // console.log(parseInt(a[6], 16));
          let val1 = parseInt(a[6], 16)
          let val2 = parseInt(a[5], 16)
          let bodytmp = (parseInt(a[6], 16) * 256 + parseInt(a[5], 16)) / 10.0
          //double room = a[8] * 256 + a[7]/10.0;

          // this.studentList.forEach(m => {
          //     if (m.checked) {
          //         m.bodyTemp = bodytmp;
          //     }
          // });

          this.studTemp = bodytmp
          this.log('> temp reading:' + bodytmp)
          // console.log(this.studentList, "temp");

          // if (this.studTemp !== "") {
          //     this.saveStudTemp();
          // }
        }
      }
    },
    onDisconnected(e) {
      let device = event.target
      this.log('Device ' + device.name + ' is disconnected.')
      console.log('Device ' + device.name + ' is disconnected.')
    },
    log() {
      var line = Array.prototype.slice
        .call(arguments)
        .map(function (argument) {
          return typeof argument === 'string' ? argument : JSON.stringify(argument)
        })
        .join(' ')

      document.querySelector('#log').textContent += line + '\n'

      $('#output-panel').show()
    },
    clearLog() {
      document.querySelector('#log').textContent = ''
      $('#output-panel').hide()
    },
    setStatus(status) {
      document.querySelector('#status').textContent = status
      $('#output-panel').show()
    },
    setContent() {
      var content = document.querySelector('#content')
      while (content.hasChildNodes()) {
        content.removeChild(content.lastChild)
      }
      content.appendChild(newContent)

      $('#output-panel').show()
    },

    async checkThermoStatus() {
      if (this.thermometerStatus === true) {
        // await this.getDevices();
        await this.startDevicesNotif()
      } else {
        // await this.onDisconnectButtonClick();
        await this.stopDevicesNotif()
      }

      // if (this.thermometerStatus === "connect") {
      //     await this.getDevices();
      // } else {
      //     await this.onDisconnectButtonClick();
      // }
    },
    async connectDevices() {
      return await this.bluetoothDevice.gatt.connect()
    },
    onDisconnectButtonClick() {
      if (!this.bluetoothDevice) {
        return
      }
      // this.log('Disconnecting from Bluetooth Device...');
      // console.log('Disconnecting from Bluetooth Device...');
      if (this.bluetoothDevice.gatt.connected) {
        this.bluetoothDevice.gatt.disconnect()
        this.devicesStatusMsg = 'Thermometer Scanner is disconnect!'
      } else {
        // this.log('> Bluetooth Device is already disconnected');
        console.log('> Bluetooth Device is already disconnected')
      }
    },

    async saveStudTemp() {
      // console.log(this.studID, "id");
      // console.log(this.studName, "name");
      // console.log(this.studTemp, "temp");
      // console.log(this.userType, "type");

      if (this.studID === '') {
        this.$notify.error({
          title: lang('Error'),
          message: 'Student index empty!',
        })
        return
      } else if (this.studName === '') {
        this.$notify.error({
          title: lang('Error'),
          message: 'Student name empty!',
        })
        return
      } else if (this.studTemp === '') {
        this.$notify.error({
          title: lang('Error'),
          message: 'Student temperature empty!',
        })
        return
      } else if (this.userType === '') {
        this.$notify.error({
          title: lang('Error'),
          message: 'In or out empty!',
        })
        return
      }

      try {
        const response = await DataSource.shared.updateAttendanceListWithTemperatureNew(
          'Individual Scan',
          this.studID,
          this.studTemp,
          this.userType,
          this.studRemark,
        )
        if (response) {
          if (response.code === '2') {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Error! Please try again later'),
            })
          } else if (response.code === '99') {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Error! Please try again later'),
            })
          } else {
            this.$notify({
              title: lang('Success'),
              message: lang('Successfully saved'),
              type: 'success',
            })

            // this.studID = "";
            // this.studName = "";
            this.studTemp = ''
            // this.selectedStudent = "";
            this.barcodeIndexNo = ''
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    onlyNumber(e) {
      // var a = [];
      // var k = e.which;
      //
      // for (var i = 48; i < 58; i++)
      //     a.push(i);
      //
      // if (!(a.indexOf(k)>=0))
      //     e.preventDefault();

      var evt = e ? e : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    async getSpecificStudent(stud_index, stud_status) {
      if (stud_index === '') {
        this.$notify.error({
          title: lang('Error'),
          message: 'Student index empty!',
        })
        return
      }

      var isExist = false
      if (this.allStudentList.length > 0) {
        this.allStudentList.forEach(m => {
          if (m.Index_No === stud_index) {
            this.studID = m.Index_No
            this.studName = m.First_Name + ' ' + m.Middle_Name + ' ' + m.Last_Name
            this.showScanDetailsModal()
            isExist = true
          }
        })
      }

      if (!isExist) {
        this.$notify.error({
          title: lang('Error'),
          message: 'Student index no not found!',
        })
        return
      }

      // this.$vs.loading();

      // stud_index = "SG-016-16-0037";
      // stud_status = "Active";

      // try {
      //     const response = await DataSource.shared.getStudentNew(stud_index, stud_status);
      //     if (response) {
      //
      //         if (response.code === '2') {
      //             console.log(response.code);
      //         } else if (response.code === '99') {
      //             this.$notify.error({
      //                 title: lang('Error'),
      //                 message: lang('Error! Please try again later')
      //             });
      //         } else {
      //             response.Table.forEach(m => {
      //                 this.studID = m.Index_No;
      //                 this.studName = m.Full_Name;
      //             });
      //         }
      //     }
      //     this.$vs.loading.close();
      // } catch (e) {
      //     this.results = e;
      // }
      // this.$vs.loading.close();
    },

    onWindowLoad() {
      let selectedDeviceId
      const codeReader = new ZXing.BrowserMultiFormatReader()
      console.log('ZXing code reader initialized')
      codeReader
        .listVideoInputDevices()
        .then(videoInputDevices => {
          const sourceSelect = document.getElementById('sourceSelect')
          selectedDeviceId = videoInputDevices[0].deviceId
          if (videoInputDevices.length >= 1) {
            videoInputDevices.forEach(element => {
              const sourceOption = document.createElement('option')
              sourceOption.text = element.label
              sourceOption.value = element.deviceId
              sourceSelect.appendChild(sourceOption)
            })

            sourceSelect.onchange = () => {
              selectedDeviceId = sourceSelect.value
            }

            const sourceSelectPanel = document.getElementById('sourceSelectPanel')
            sourceSelectPanel.style.display = 'block'
          }

          document.getElementById('startButton').addEventListener('click', () => {
            codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
              if (result) {
                // console.log(result);
                alert(result)
                this.scanStudIndex = result.text
                this.selectedStudent = result.text
                this.getSpecificStudent(this.scanStudIndex, 'Active')
                document.getElementById('result').textContent = result.text
              }
              if (err && !(err instanceof ZXing.NotFoundException)) {
                console.error(err)
                this.$notify.error({
                  title: lang('Error'),
                  message: lang('Error! Please try again later'),
                })
                document.getElementById('result').textContent = err
              }
            })
            console.log(`Started continous decode from camera with id ${selectedDeviceId}`)
          })

          // document.getElementById('resetButton').addEventListener('click', () => {
          //     codeReader.reset();
          //     document.getElementById('result').textContent = '';
          //     console.log('Reset.');
          // });
        })
        .catch(err => {
          console.error(err)
        })
    },

    async getAllStudent() {
      this.$vs.loading()

      try {
        const response = await DataSource.shared.getAllActiveStudentsBySchoolWithMode('Dashboard')
        if (response) {
          if (response.code === '2') {
            console.log(response.code)
          } else if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: lang('Error'),
              message: lang('Error! Please try again later'),
            })
          } else {
            response.Table.forEach((resp, respIndex) => {
              resp.fullName = resp.First_Name + resp.Middle_Name + resp.Last_Name
            })

            this.allStudentList = response.Table
            this.filterAllStudentList = this.allStudentList
          }

          // console.log(this.allStudentList, "all list");
        }
        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    changeStudent(studIndexNo) {
      this.scanStudIndex = studIndexNo
      this.getSpecificStudent(this.scanStudIndex, 'Active')
    },

    triggerStartClick() {
      var start = document.getElementById('startButton')
      start.click()
    },

    checkBarcodeStatus() {
      if (this.barcodeStatus === 'start') {
        this.triggerStartScan()
      } else {
        this.triggerStopScan()
      }
    },

    triggerStartScan() {
      if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function') {
        let self = this

        Quagga.init(
          {
            inputStream: {
              type: 'LiveStream',
              constraints: {
                width: { min: 1280 },
                height: { min: 720 },
                aspectRatio: { min: 1, max: 100 },
                facingMode: 'environment', // or user
              },
            },
            decoder: {
              readers: ['code_39_reader'],
            },
            numOfWorkers: 0,
            frequency: 10,
            locate: true,
            locator: {
              patchSize: 'x-small',
              halfSample: true,
            },
          },
          function (err) {
            if (err) {
              console.log(err)
              return
            }
            console.log('Initialization finished. Ready to start')
            self.initCameraSelection()
            Quagga.start()
          },
        )

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
            drawingCanvas = Quagga.canvas.dom.overlay

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width')), parseInt(drawingCanvas.getAttribute('height')))
              result.boxes
                .filter(function (box) {
                  return box !== result.box
                })
                .forEach(function (box) {
                  Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: 'green', lineWidth: 2 })
                })
            }

            if (result.box) {
              // Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
            }

            if (result.codeResult && result.codeResult.code) {
              // Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
            }
          }
        })

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code

          console.log(code)
          self.scanStudIndex = code
          self.selectedStudent = code
          self.studTemp = ''
          self.getSpecificStudent(self.scanStudIndex, 'Active')

          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;
          //
          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        })
      }

      // Quagga.start();
    },

    triggerStopScan() {
      Quagga.stop()
    },

    initCameraSelection() {
      var streamLabel = Quagga.CameraAccess.getActiveStreamLabel()

      return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
        function pruneText(text) {
          return text.length > 30 ? text.substr(0, 30) : text
        }
        var $deviceSelection = document.getElementById('deviceSelection')
        while ($deviceSelection.firstChild) {
          $deviceSelection.removeChild($deviceSelection.firstChild)
        }
        devices.forEach(function (device) {
          var $option = document.createElement('option')
          $option.value = device.deviceId || device.id
          $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)))
          $option.selected = streamLabel === device.label
          $deviceSelection.appendChild($option)
        })
      })
    },

    showScanDetailsModal() {
      this.$refs.modal_ScanDetails.show()
    },

    hideScanDetailsModal() {
      this.$refs.modal_ScanDetails.hide()

      this.studID = ''
      this.studName = ''
      this.studTemp = ''
      this.selectedStudent = ''
    },

    onDecode(result) {
      // this.result = result

      this.scanStudIndex = result
      this.selectedStudent = result
      this.studTemp = ''
      this.getSpecificStudent(this.scanStudIndex, 'Active')
    },

    async onInit(promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.$notify.error({
            title: lang('Error'),
            message: 'ERROR: you need to grant camera access permisson',
          })
        } else if (error.name === 'NotFoundError') {
          this.$notify.error({
            title: lang('Error'),
            message: 'ERROR: no camera on this device',
          })
        } else if (error.name === 'NotSupportedError') {
          this.$notify.error({
            title: lang('Error'),
            message: 'ERROR: secure context required (HTTPS, localhost)',
          })
        } else if (error.name === 'NotReadableError') {
          this.$notify.error({
            title: lang('Error'),
            message: 'ERROR: is the camera already in use?',
          })
        } else if (error.name === 'OverconstrainedError') {
          this.$notify.error({
            title: lang('Error'),
            message: 'ERROR: installed cameras are not suitable',
          })
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.$notify.error({
            title: lang('Error'),
            message: 'ERROR: Stream API is not supported in this browser',
          })
        }
      }
    },

    searchStudent() {
      this.filterAllStudentList = this.allStudentList.filter(x => x.fullName.toLowerCase().includes(this.searchValue))
      // this.filterAllStudentList = this.allStudentList.filter(x => x.Index_No.toLowerCase().includes(this.searchValue));
      //
    },

    showSearch() {
      if (this.isSearch === true) {
        this.isSearch = false
      } else {
        this.isSearch = true
      }
    },

    closeScanModal() {
      this.barcodeIndexNo = ''
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
      } else {
        this.checkMobileStatus = false
      }
    },
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
  },
  watch: {},
}
</script>

<style scoped>
.student-search {
  background-image: url('../assets/Vector23.png') !important;
  background-position: 95% center !important;
  background-repeat: no-repeat !important;
  width: 100%;
  font-size: 16px;
  padding: 0.375rem 40px 0.375rem 0.75rem;
}

.student-search::placeholder {
  color: #91a3b6;
  font-size: 12px;
}

.student-each-container {
  text-align: left;
  border-bottom: 1px solid #d3d9e8;
  padding: 5px;
  cursor: pointer;
}
</style>
